/* global  */ // tUrl等のグローバル変数を宣言する
import './_schedule'
import './_job'
import './_tokuyo'

import 'core-js/features/number/is-nan' // SwiperのIE対応
import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

//   ####  ##      ##  ####    #####
//  ##     ##      ##  ##  ##  ##
//   ###   ##      ##  ##  ##  #####
//     ##  ##      ##  ##  ##  ##
//  ####   ######  ##  ####    #####
//            ###    ###  ##   ##
//            ## #  # ##  ##   ##
//  ########  ##  ##  ##  ##   ##
//            ##      ##   ## ##
//            ##      ##    ###

if (document.getElementById('topMv')) {
  // Swiperコンテナを検出したら実行
  const slideItem = document.getElementById('topMv')
  // eslint-disable-next-line no-unused-vars
  const topMvSwiper = new Swiper(slideItem, {
    // init: false, // 自動で初期化しない（topMvSwiper.init()で初期化）
    effect: 'fade', // slide,fade,cube,coverflow
    speed: 2000, // アニメ速度
    loop: true, // ループ
    preloadImages: false, // スライド内の画像を読み終えてから開始
    simulateTouch: false, // マウスドラッグでスワイプ操作　無効でテキスト選択が可能に
    touchRatio: 0, // タッチスワイプ感度（0でタッチスワイプ無効）
    fadeEffect: {
      // フェードオプション
      crossFade: true, // クロスフェード
    },
    autoplay: {
      // オートオプション
      delay: 5000, // 待機時間
      disableOnInteraction: false, // 操作されたら停止する
    },
  })

  topMvSwiper.on('slideChangeTransitionEnd', function () {
    //スライド完了時のトリガー
    const slideAnimeStay = document.getElementsByClassName('js-slideAnimeStay')
    if (slideAnimeStay[0]) {
      // 初回はズームアニメさせないためのクラスを外す
      // for (const item of slideAnimeStay) {
      //   item.classList.remove('stay')
      //   item.classList.remove('js-slideAnimeStay')
      // }
    }
  })
}

//             ####  ######    ###    #####  #####
//            ##       ##     ## ##   ##     ##
//  ########   ###     ##    ##   ##  #####  #####
//               ##    ##    #######  ##     ##
//            ####     ##    ##   ##  ##     ##

if (document.getElementById('staffOther')) {
  // Swiperコンテナを検出したら実行
  // eslint-disable-next-line no-unused-vars
  const slideItem = document.getElementById('staffOther')
  const sliderName = 'staffOther'
  const staffOtherSwiper = new Swiper(slideItem, {
    // init: false, // 自動で初期化しない（staffOtherSwiper.init()で初期化）
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 500, // アニメ速度
    loop: true, // ループ
    preloadImages: false, // スライド内の画像を読み終えてから開始
    slidesPerView: 1.2, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
    centeredSlides: true, // 中央のスライドを基準にする
    autoHeight: true, // スライドごとに高さを変動させる
    autoplay: {
      // オートオプション
      delay: 5000, // 待機時間
      disableOnInteraction: false, // 操作されたら停止する
      pauseOnMouseEnter: true, // マウスオーバー中は一時停止する
    },
    navigation: {
      nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
      prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
    },
    breakpoints: {
      // 指定px以上でオプション切り替え
      769: {
        slidesPerView: 1.8, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
      },
      900: {
        slidesPerView: 2.2, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
      },
      1100: {
        slidesPerView: 2.6, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
      },
      1200: {
        slidesPerView: 3, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
      },
    },
  })
}

//            ########     ###    ##    ##  ######  ######## ########  ##     ## ####  ###### ########
//            ##     ##  ##   ##   ##  ##  ##       ##       ##     ## ##     ##  ##  ##      ##
//  ########  ##     ## ##     ##    ##     ######  ######   ########  ##     ##  ##  ##      ######
//            ##     ## #########    ##          ## ##       ##   ##    ##   ##   ##  ##      ##
//            ########  ##     ##    ##     ######  ######## ##     ##    ###    ####  ###### ########
let dayserviceSwiper
if (document.getElementById('dayserviceSupportFood')) {
  // SP時だけスライダーにする
  let dayserviceSwiperActive = false
  if (window.matchMedia('(max-width:768px)').matches) {
    dayserviceSwiperInit()
    dayserviceSwiperActive = true
  }
  window.addEventListener('resize', function (e) {
    if (dayserviceSwiperActive && window.matchMedia('(min-width:769px)').matches) {
      dayserviceSwiper.destroy()
      dayserviceSwiperActive = false
    } else if (!dayserviceSwiperActive && window.matchMedia('(max-width:768px)').matches) {
      dayserviceSwiperInit()
      dayserviceSwiperActive = true
    }
  })
}
function dayserviceSwiperInit() {
  const slideItem = document.getElementById('dayserviceSupportFood')
  const sliderName = 'dayserviceSupportFood'
  dayserviceSwiper = new Swiper(slideItem, {
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 500, // アニメ速度
    loop: true, // ループ
    autoplay: {
      // オートオプション
      delay: 5000, // 待機時間
      disableOnInteraction: false, // 操作されたら停止する
      pauseOnMouseEnter: true, // マウスオーバー中は一時停止する
    },
    navigation: {
      nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
      prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
    },
    pagination: {
      el: '.swiper-pagenation--' + sliderName,
      type: 'bullets',
      clickable: true,
    },
  })
}

//            ##     ## ######## ##       ########  ######## ########
//            ##     ## ##       ##       ##     ## ##       ##     ##
//  ########  ######### ######   ##       ########  ######   ########
//            ##     ## ##       ##       ##        ##       ##   ##
//            ##     ## ######## ######## ##        ######## ##     ##
let helperstationSwiper
if (document.getElementById('helperstationSupport')) {
  // SP時だけスライダーにする
  let helperstationSwiperActive = false
  if (window.matchMedia('(max-width:768px)').matches) {
    helperstationSwiperInit()
    helperstationSwiperActive = true
  }
  window.addEventListener('resize', function (e) {
    if (helperstationSwiperActive && window.matchMedia('(min-width:769px)').matches) {
      helperstationSwiper.destroy()
      helperstationSwiperActive = false
    } else if (!helperstationSwiperActive && window.matchMedia('(max-width:768px)').matches) {
      helperstationSwiperInit()
      helperstationSwiperActive = true
    }
  })
}
function helperstationSwiperInit() {
  const slideItem = document.getElementById('helperstationSupport')
  const sliderName = 'helperstationSupport'
  dayserviceSwiper = new Swiper(slideItem, {
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 500, // アニメ速度
    loop: true, // ループ
    autoplay: {
      // オートオプション
      delay: 5000, // 待機時間
      disableOnInteraction: false, // 操作されたら停止する
      pauseOnMouseEnter: true, // マウスオーバー中は一時停止する
    },
    navigation: {
      nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
      prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
    },
    pagination: {
      el: '.swiper-pagenation--' + sliderName,
      type: 'bullets',
      clickable: true,
    },
  })
}

//            ########  ########  ###### ########  ##     ## #### ########
//            ##     ## ##       ##      ##     ## ##     ##  ##     ##
//  ########  ########  ######   ##      ########  ##     ##  ##     ##
//            ##   ##   ##       ##      ##   ##   ##     ##  ##     ##
//            ##     ## ########  ###### ##     ##  #######  ####    ##

if (document.getElementById('recruitMv')) {
  const slideItem = document.getElementById('recruitMv')
  const sliderName = 'recruitMv'
  const recruitSwiper = new Swiper(slideItem, {
    effect: 'slide', // slide,fade,cube,coverflow
    speed: 500, // アニメ速度
    loop: true, // ループ
    slidesPerView: 2.5, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
    spaceBetween: -100,
    centeredSlides: true, // 中央のスライドを基準にする
    autoplay: {
      delay: 5000, // 待機時間
      disableOnInteraction: false, // 操作されたら停止する
      pauseOnMouseEnter: true, // マウスオーバー中は一時停止する
    },
    pagination: {
      el: '.swiper-pagenation--' + sliderName,
      type: 'bullets',
      clickable: true,
    },
    breakpoints: {
      769: {
        slidesPerView: 5, //表示数変更 小数指定可　'auto' + .swiper-slide{width:auto;}で可変化
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
          prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
        },
      },
    },
  })
}

/*
   ###     ######   ######
 ##   ##  ##       ##
##     ## ##       ##
######### ##       ##
##     ##  ######   ######
*/
if (window.matchMedia('(max-width:768px)').matches) {
  $('.js-facilities-traning-acc').on('click', function () {
    $(this).toggleClass('open')
    $(this).next().slideToggle()
  })
  $('.js-pagenav-acc').on('click', function () {
    $(this).toggleClass('open')
    $(this).next().slideToggle()
  })
}

/*
##     ##  #######  ########     ###    ##
#### #### ##     ## ##     ##  ##   ##  ##
## ### ## ##     ## ##     ## ##     ## ##
##     ## ##     ## ##     ## ######### ##
##     ##  #######  ########  ##     ## ########
*/
$('.js-facilitiesModal-open').on('click', function () {
  openModal($(this).next())
  return false
})
$('.js-facilitiesModal-close').on('click', function () {
  closeModal($(this).closest('.js-facilitiesModal-modal'))
})
$('.js-facilitiesModal-modal').on('click', function () {
  closeModal($(this))
})
$('.js-facilitiesModal-content').on('click', function (e) {
  e.stopPropagation()
})
let scrollTop
// モーダル開く
function openModal(el) {
  let elModal = el
  let elModalContent = elModal.children('.js-facilitiesModal-content')
  scrollTop = $(window).scrollTop()
  elModal.addClass('active')
  elModal.scrollTop(0)
  $('body').addClass('modalOn')
  $('body').css({ top: -1 * scrollTop })
  if (navigator.userAgent.indexOf('iPhone') !== -1 || navigator.userAgent.indexOf('iPad') !== -1) {
    for (let i = 0; i < elModalContent.length; i++) {
      elModalContent[i].addEventListener(
        'touchmove',
        function (e) {
          const scroll = elModalContent.scrollTop
          const range = elModalContent.scrollHeight - elModalContent.offsetHeight - 1
          if (scroll < 1) {
            e.preventDefault()
            elModalContent.scrollTop = 1
          } else if (scroll > range) {
            e.preventDefault()
            elModalContent.scrollTop = range
          }
        },
        { passive: false }
      )
    }
  }
  el.find('.scroll-hint-icon').addClass('active')
}
// モーダル閉じる
function closeModal(el) {
  el.removeClass('active')
  $('body').removeClass('modalOn')
  $(window).scrollTop(scrollTop)
  el.find('.scroll-hint-icon').removeClass('active')
}

/*
######## ########  ##     ## ##    ## ##    ##  #######
   ##    ##     ## ##     ## ####  ## ##  ##   ##     ##
   ##    ########  ##     ## ## ## ## #####     #######
   ##    ##   ##   ##     ## ##  #### ##  ##   ##     ##
   ##    ##     ##  #######  ##    ## ##    ##  #######
*/
if ($('.js-t8')[0]) {
  trunk8()
}
function trunk8() {
  // 指定要素に行数制限をかける
  $('.js-t8.line4').trunk8({
    lines: 4,
    fill: '...',
  })
}

/*
        ##  ######          #### ##    ##
        ## ##                ##  ####  ##
        ##  ######  #######  ##  ## ## ##
  ##    ##       ##          ##  ##  ####
   ######   ######          #### ##    ##
*/
$(function () {
  if (document.getElementsByClassName('js-in')[0]) {
    // 画面に入った監視対象に.animatedを付加
    // Intersection Observer
    intObs()
  }
  function intObs() {
    let rootMargin = '-10px 0px'
    if (window.matchMedia('(max-width:768px)').matches) {
      //SPは検出を早くする
      rootMargin = '100px 0px'
    }
    const intObsOption = {
      // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
      rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
      threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
    }
    const observer = new IntersectionObserver(intObsCallback, intObsOption)
    const intObsItems = document.getElementsByClassName('js-in')
    for (let index = 0; index < intObsItems.length; index++) {
      const intObsItem = intObsItems[index]
      observer.observe(intObsItem) // 監視対象に加える
    }
    function intObsCallback(entries) {
      for (let index = 0; index < entries.length; index++) {
        const entry = entries[index]
        if (entry.isIntersecting) {
          const entryItem = entry.target
          entryItem.classList.add('active')
          observer.unobserve(entryItem) // 監視対象から外す
        }
      }
    }
  }
})

$(function () {
  $('.gNavBtn__box').click(function () {
    $('.header').toggleClass('gra')
  })
})

//   ####    ##   ##  ##  ####    #####
//  ##       ##   ##  ##  ##  ##  ##
//  ##  ###  ##   ##  ##  ##  ##  #####
//  ##   ##  ##   ##  ##  ##  ##  ##
//   ####     #####   ##  ####    #####

const touchGuide = document.getElementsByClassName('js-touchGuide')
const touchGuideItem = document.getElementsByClassName('js-touchGuide-item')
if (touchGuide[0]) {
  for (const iterator of touchGuide) {
    iterator.addEventListener('touchend', function (e) {
      for (const pinchItem of touchGuideItem) {
        pinchItem.classList.remove('active')
      }
    })
  }
}
